import * as Sentry from '@sentry/react';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { Env } from './common/constants/env';

dayjs.extend(utc);
dayjs.extend(timezone);

const currentEnv = process.env.UMI_ENV || Env.DEV;

Sentry.init({
  dsn: 'https://0af622e5dd28a273c7ad07b00f10c680@o4509959913537536.ingest.us.sentry.io/4511068851339264',
  enabled: currentEnv === Env.PROD,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  tracesSampleRate: 1.0, // 可以根据用户量自行设置上报比例 1为100%
  environment: currentEnv,
  debug: currentEnv !== Env.PROD,
  beforeSend(event, hint) {
    if (currentEnv !== Env.PROD) {
      console.log('🔥 Sentry beforeSend called:', {
        level: event.level,
        exception: event.exception,
        message: event.message,
        originalException: hint.originalException,
      });
    }

    return event;
  },
});
